import '../styles/homescreen.css';
import {Logo} from "../components/Logo";

const Homepage = () => {
  return (
     <div className="homescreen__background">
       <div className='homescreen__titles'>
         <Logo />
       </div>
    </div>
    
  )
}

export default Homepage
